
import { Button, IconButton } from '@mui/material';
import './FicusMobile.css';
import ficus1 from "../../../../../assets/ficus/ficus-australis.jpg";
import ficus2 from "../../../../../assets/ficus/ficus-hawaii.webp";
import ficus3 from "../../../../../assets/ficus/ficus-benjamina1.webp";
import ficus4 from "../../../../../assets/ficus/ficus-nitida-2.jpg";
import ficus5 from "../../../../../assets/ficus/ficus-lyrata1.webp";
import ficus6 from "../../../../../assets/Indoors/in11.jpeg";
import indoor111 from "../../../../../assets/Indoors/bonsaii-small.jpeg";
import indoor112 from "../../../../../assets/Indoors/bonsaii-medium.jpeg";
import indoor113 from "../../../../../assets/Indoors/bonsaii-large.jpeg";
import indoor114 from "../../../../../assets/Indoors/bonsai-1 (1).jpeg";
import indoor115 from "../../../../../assets/Indoors/bonsai-1 (9).jpeg";
import indoor116 from "../../../../../assets/Indoors/bonsai-1 (8).jpeg";
import indoor117 from "../../../../../assets/Indoors/bonsai-1 (7).jpeg";
import indoor118 from "../../../../../assets/Indoors/bonsai-1 (6).jpeg";
import indoor119 from "../../../../../assets/Indoors/bonsai-1 (5).jpeg";
import indoor1191 from "../../../../../assets/Indoors/bonsai-1 (4).jpeg";
import indoor1192 from "../../../../../assets/Indoors/bonsai-1 (3).jpeg";
import indoor1193 from "../../../../../assets/Indoors/bonsai-1 (2).jpeg";
import indoor1194 from "../../../../../assets/Indoors/bonsai-1 (11).jpeg";
import indoor1195 from "../../../../../assets/Indoors/bonsai-1 (10).jpeg";
import indoor471 from "../../../../../assets/Indoors/bonsaii-s-sm.jpeg";
import indoor472 from "../../../../../assets/Indoors/bonsaii-s-md.jpeg";
import indoor473 from "../../../../../assets/Indoors/bonsaii-s-large.jpeg"
import indoor12 from "../../../../../assets/Indoors/in12.jpeg";
import indoor121 from "../../../../../assets/Indoors/ficus-panda1.jpeg";
import indoor13 from "../../../../../assets/Indoors/in13.jpeg";
import indoor131 from "../../../../../assets/Indoors/ficus-benjamin-det.jpeg";
import indoor49 from "../../../../../assets/Indoors/Ficus-lyrata.webp";
import indoor491 from "../../../../../assets/Indoors/Ficus-lyrata-sm.jpeg";
import indoor492 from "../../../../../assets/Indoors/Ficus-lyrata-md.jpeg";
import indoor51 from "../../../../../assets/Indoors/ficus-benjamina-cage.jpg";
import indoor511 from "../../../../../assets/Indoors/ficus-benjamina cage-sm.jpeg";
import indoor512 from "../../../../../assets/Indoors/ficus-benjamina cage-md.jpeg";
import indoor513 from "../../../../../assets/Indoors/ficus-benjamina cage-lg.jpeg"
import indoor16 from "../../../../../assets/Indoors/in16.jpeg";
import indoor52 from "../../../../../assets/Indoors/ficus-king.webp";
import indoor521 from "../../../../../assets/Indoors/ficus-king-det.jpeg";

import indoor53 from "../../../../../assets/Indoors/ficus-benj.jpg";
import indoor531 from "../../../../../assets/Indoors/ficus-benj-det.jpeg";

import indoor54 from "../../../../../assets/Indoors/ficus-stresse.jpg";
import indoor541 from "../../../../../assets/Indoors/ficus-stress-sm.jpeg";
import indoor542 from "../../../../../assets/Indoors/ficus-stress-md.jpeg";
import indoor56 from "../../../../../assets/Indoors/ficus-8.avif";
import indoor561 from "../../../../../assets/Indoors/ficus-8-small.jpeg";
import indoor562 from "../../../../../assets/Indoors/ficus-8-md.jpeg";

import indoor57 from "../../../../../assets/Indoors/ficus-net.jpg";
import indoor571 from "../../../../../assets/Indoors/ficus-net-det.jpeg";

import indoor60 from "../../../../../assets/Indoors/areca.webp";
import indoor601 from "../../../../../assets/Indoors/areca-xs.jpeg";
import indoor602 from "../../../../../assets/Indoors/areca-s.jpeg";
import indoor603 from "../../../../../assets/Indoors/areca-m.jpeg";
import indoor604 from "../../../../../assets/Indoors/areca-l.jpeg";
import indoor605 from "../../../../../assets/Indoors/areca-xl.jpeg";


import indoor61 from "../../../../../assets/Indoors/ficus-elastica-red.webp";
import indoor611 from "../../../../../assets/Indoors/ficus-elastica-red-sm.jpeg";
import indoor612 from "../../../../../assets/Indoors/ficus-elastica-red-md.jpeg";

import indoor62 from "../../../../../assets/Indoors/elastica-green-white.jpg";
import indoor621 from "../../../../../assets/Indoors/elastica-green-white-sm.jpeg";
import indoor622 from "../../../../../assets/Indoors/elastica-green-white-md.jpeg";
import indoor623 from "../../../../../assets/Indoors/elastica-green-white-lg.jpeg";

import indoor63 from "../../../../../assets/Indoors/ficus-elastica-green.webp";
import indoor631 from "../../../../../assets/Indoors/elastica-green-sm.jpeg";
import indoor632 from "../../../../../assets/Indoors/elastica-green-md.jpeg";

import indoor64 from "../../../../../assets/Indoors/bamboo-variegated.jpg";
import indoor641 from "../../../../../assets/Indoors/bamboo-variegated-det.jpeg";

import indoor65 from "../../../../../assets/Indoors/fiucs-hawaii-tige.jpg";
import indoor651 from "../../../../../assets/Indoors/ficus-hawaii-tige-sm.jpeg";
import indoor652 from "../../../../../assets/Indoors/ficus-hawaii-tige-md.jpeg"

import indoor66 from "../../../../../assets/Indoors/ficus-hawaii-touffe.jpg";
import indoor661 from "../../../../../assets/Indoors/ficus hawaii-touffe-det.jpeg";

import indoor67 from "../../../../../assets/Indoors/ficus-panda-tige.webp";
import indoor671 from "../../../../../assets/Indoors/ficus-panda-tige1.jpeg";

import indoor68 from "../../../../../assets/Indoors/ficus-panda-pyramid.webp";
import indoor681 from "../../../../../assets/Indoors/ficus-panda-pyramid1.jpeg";


import indoor69 from "../../../../../assets/Indoors/ficus-panda-boule.webp";
import indoor691 from "../../../../../assets/Indoors/ficus-panda-boule1.jpeg";


import indoor70 from "../../../../../assets/Indoors/ficus-panda-3heads.webp";
import indoor701 from "../../../../../assets/Indoors/ficus-panda-3heads1.jpeg";

import indoor71 from "../../../../../assets/Indoors/ficus-panda-multiheads.jpg";
import indoor711 from "../../../../../assets/Indoors/ficus-panda-multiheads1.jpeg";
import BackIcon from '../../../../../components/back/back';
import { useNavigate } from 'react-router-dom';

type GalleryImage = {
    src: string;
    size?: string;
    name?: string;
};


type IndoorFamily = {
    id: number;
    name: string;
    img: string;
    description: string;
    gallery: GalleryImage[];
};
export const FicusFamilies: IndoorFamily[] = [
    {
        id: 1,
        name: "Ficus Australis",
        img: ficus1,
        description:
            "Ficus Australis is a resilient ornamental fig with glossy green leaves and a sturdy growth habit. It adapts well to indoor spaces, adding a lush, tropical feel while requiring only moderate care.",
        gallery: [{ src: ficus1 }],
    },
    {
        id: 2,
        name: "Ficus Hawaii",
        img: ficus2,
        description:
            "Ficus Hawaii is known for its attractive, variegated foliage with shades of green, cream, and yellow. A popular indoor plant, it brings a vibrant, decorative touch to homes and offices.",
        gallery: [{ src: ficus2 }],
    },
    {
        id: 3,
        name: "Ficus Benjamina",
        img: ficus3,
        description:
            "Commonly called the Weeping Fig, Ficus Benjamina features slender branches with gracefully drooping, glossy leaves. It thrives indoors with bright, indirect light and helps purify the air.",
        gallery: [{ src: ficus3 }],
    },
    {
        id: 4,
        name: "Ficus Nitida",
        img: ficus4,
        description:
            "Ficus Nitida, also known as Indian Laurel Fig, has dense, glossy foliage and is often used as an indoor ornamental tree. It is easy to maintain and provides a refreshing, green accent to interiors.",
        gallery: [{ src: ficus4 }],
    },
    {
        id: 5,
        name: "Ficus Lytarata",
        img: ficus5,
        description:
            "Better known as the Fiddle Leaf Fig, Ficus Lytarata is admired for its large, violin-shaped leaves and dramatic presence. It makes a bold statement in any room and thrives in bright, filtered light.",
        gallery: [{ src: ficus5 }],
    },
    {
        id: 6,
        name: "Ficus Bonsaii",
        img: ficus6,
        description:
            "Ficus Bonsaii is a miniature tree cultivated in the bonsai style. With its elegant trunk and lush foliage, it symbolizes balance and serenity, making it a perfect decorative plant for indoor settings.",
        gallery: [
            { src: indoor111, size: 'small', name: "ficus Bonsaii" },
            { src: indoor112, size: 'medium', name: "ficus Bonsaii" },
            { src: indoor113, size: 'large', name: "ficus Bonsaii" },
            { src: indoor471, size: 'small', name: "ficus Bonsaii S" },
            { src: indoor472, size: 'medium', name: "ficus Bonsaii S" },
            { src: indoor473, size: 'large', name: "ficus Bonsaii S" },
            { src: indoor114 },
            { src: indoor115 },
            { src: indoor116 },
            { src: indoor117 },
            { src: indoor118 },
            { src: indoor119 },
            { src: indoor1191 },
            { src: indoor1192 },
            { src: indoor1193 },
            { src: indoor1194 },
            { src: indoor1195 },

        ],
    },
    {
        id: 12,
        name: "Ficus Panda",
        img: indoor12,
        description: "A rounded, lush ficus with dense green leaves.",
        gallery: [{ src: indoor121 }],
    },
    {
        id: 13,
        name: "Ficus Benjamina",
        img: indoor13,
        description: "Also known as weeping fig, with glossy leaves and flowing branches.",
        gallery: [{ src: indoor131 }],
    },
    {
        id: 16,
        name: "Ficus Hawaii",
        img: indoor16,
        description: "Attractive variegated ficus with tropical vibes.",
        gallery: [{ src: indoor16 }],
    },
    {
        id: 51,
        name: "Ficus benjamina Cage",
        img: indoor51,
        description: "The Ficus benjamina Cage is a decorative variety of the weeping fig, often styled in braided or caged forms. It has glossy green leaves and a graceful growth habit, making it ideal for adding greenery with a sculptural touch to interiors.",
        gallery: [
            { src: indoor513, size: "small" },
            { src: indoor512, size: "medium" },
            { src: indoor511, size: "large" },
        ],
    },
    {
        id: 52,
        name: "Ficus binnendijkii Amstel King",
        img: indoor52,
        description: "The Ficus binnendijkii Amstel King is a hardy indoor plant with long, narrow, glossy green leaves. Its upright and bushy form makes it an excellent choice for filling corners and adding tropical greenery indoors. It tolerates lower light conditions compared to other ficus varieties.",
        gallery: [
            { src: indoor521 },
        ],
    },
    {
        id: 53,
        name: "Ficus benj. Exotica Spiral",
        img: indoor53,
        description: "The Ficus benjamina Exotica Spiral is a stylish variety of the weeping fig, often trained into a spiral trunk form. With glossy green leaves and an elegant shape, it is both decorative and functional, adding a sophisticated touch to homes and offices.",
        gallery: [
            { src: indoor531 },
        ],
    },
    {
        id: 54,
        name: "Ficus benjamina Stresse",
        img: indoor54,
        description: "The Ficus benjamina Stresse is a unique variety of the weeping fig known for its distinctive leaf shape and graceful growth. It adds a refreshing green accent indoors and adapts well to various light conditions, making it a versatile decorative plant.",
        gallery: [
            { src: indoor541, size: "small" },
            { src: indoor542, size: "medium" },
        ],
    },
    {
        id: 56,
        name: "Ficus Bonsaii 8",
        img: indoor56,
        description: "The Ficus Bonsai is a miniature version of the ficus tree, admired for its thick trunk, aerial roots, and glossy green leaves. It symbolizes harmony and balance, making it a popular choice for bonsai enthusiasts and indoor décor.",
        gallery: [
            { src: indoor561, size: "small" },
            { src: indoor562, size: "medium" },
        ],
    },
    {
        id: 57,
        name: "Ficus Bonsai Net shape",
        img: indoor57,
        description: "This unique Ficus Bonsai, trained into a net-like shape, combines artistic design with the natural beauty of bonsai. Its sculpted form and dense foliage bring elegance and creativity to any indoor setting.",
        gallery: [
            { src: indoor571 },
        ],
    },

    {
        id: 61,
        name: "Ficus Elastica Red",
        img: indoor61,
        description: "A bold rubber plant with deep burgundy leaves. It is hardy, stylish, and thrives in bright, indirect light with minimal care.",
        gallery: [
            { src: indoor611, size: "small" },
            { src: indoor612, size: "medium" },
        ],
    },
    {
        id: 62,
        name: "Ficus Elastica Green&White",
        img: indoor62,
        description: "A striking rubber plant with creamy white and green variegated leaves. It grows well in bright filtered light and adds elegance to indoor spaces.",
        gallery: [
            { src: indoor621, size: "small" },
            { src: indoor622, size: "medium" },
            { src: indoor623, size: "large" },
        ],
    },
    {
        id: 63,
        name: "Ficus Elastica Green",
        img: indoor63,
        description: "A classic, glossy-leaf rubber plant that is durable, low-maintenance, and perfect for modern homes and offices.",
        gallery: [
            { src: indoor631, size: "small" },
            { src: indoor632, size: "medium" },
        ],
    },
 
    {
        id: 65,
        name: "Ficus Hawaii Tige",
        img: indoor65,
        description: "A tall, trunk-style ficus with lush patterned leaves. It brings height and freshness to interiors and thrives in bright indirect light.",
        gallery: [
            { src: indoor651, size: "small" },
            { src: indoor652, size: "medium" },
        ],
    },
    {
        id: 66,
        name: "Ficus Hawaii Touffe",
        img: indoor66,
        description: "A full, bushy ficus variety with dense variegated foliage. Ideal for bright indoor spaces that need a vibrant tropical touch.",
        gallery: [
            { src: indoor661 },
        ],
    },
    {
        id: 67,
        name: "Ficus Panda Tige",
        img: indoor67,
        description: "A sculpted ficus with an upright trunk and rounded green foliage. Elegant, easy to maintain, and perfect as a statement indoor plant.",
        gallery: [
            { src: indoor671 },
        ],
    },
    {
        id: 68,
        name: "Ficus Panda pyramid",
        img: indoor68,
        description: "A uniquely shaped ficus pruned into a pyramid form. Decorative and structured, it adds artistic greenery to any indoor space.",
        gallery: [
            { src: indoor681 },
        ],
    },
    {
        id: 69,
        name: "Ficus Panda boule",
        img: indoor69,
        description: "A beautifully rounded ficus shaped into a ball form. Low-maintenance and ideal for adding symmetry and style indoors.",
        gallery: [
            { src: indoor691 },
        ],
    },
    {
        id: 70,
        name: "Ficus Panda 3 heads",
        img: indoor70,
        description: "A multi-stem ficus featuring three rounded tops. Its sculpted structure makes it a standout decorative indoor plant.",
        gallery: [
            { src: indoor701 },
        ],
    },
    {
        id: 71,
        name: "Ficus Panda multi heads",
        img: indoor71,
        description: "A multi-headed ficus with several rounded foliage clusters, offering a lush, architectural look for modern interiors.",
        gallery: [
            { src: indoor711 },
        ],
    },
];


export default function FicusCategorieMobile() {
    const navigate = useNavigate();

    const handleClick = (name: any) => {
        navigate(`/ficus/${name}`);
    };

    return (
        <div className="ficus-container-mobile">
            <BackIcon />
            <div className="title-overlay" style={{ marginTop: "1rem" }}>
                <h1 className="title-modern-mobile">Ficus Collection</h1>
            </div>
            <div className="plants-category-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" >
                {FicusFamilies.map((ficus) => (
                    <div key={ficus.id} onClick={() => handleClick(ficus.name)} className=" ficus-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105">
                        <img
                            src={ficus.img}
                            alt={ficus.name}
                            className="w-full h-60 object-cover rounded-lg mb-4"
                        />
                        <p className="plant-name">{ficus.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
